import { render, staticRenderFns } from "./PdfUpload.vue?vue&type=template&id=a6566864&scoped=true"
import script from "./PdfUpload.vue?vue&type=script&lang=js"
export * from "./PdfUpload.vue?vue&type=script&lang=js"
import style0 from "./PdfUpload.vue?vue&type=style&index=0&id=a6566864&prod&lang=scss&scoped=true"
import style1 from "./PdfUpload.vue?vue&type=style&index=1&id=a6566864&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6566864",
  null
  
)

export default component.exports